// Content schema for dynamic content management
export const CONTENT_SCHEMA = {
  home: {
    // Section 1 - Hero Section (4 slides)
    hero: {
      slides: [
        {
          heading: 'Welcome to Ampthilldowns',
          subheading:
            'An eco-stay in the mountains where nature and comfort come together',
          backgroundImage: '',
          backgroundVideo: '',
        },
        {
          heading: 'Imagine spending your day',
          subheading: 'listening to birds chirping, the wind whistling past',
          backgroundImage: '',
          backgroundVideo: '',
        },
        {
          heading: 'Creating Memorable Experiences',
          subheading: 'Adventures, relaxation and wellness',
          backgroundImage: '',
          backgroundVideo: '',
        },
        {
          heading: "We can't wait to take care of you",
          subheading: 'Live the Mountain Experience. Be our Guest',
          backgroundImage: '',
          backgroundVideo: '',
        },
      ],
      ctaText: 'Book Your Stay',
    },

    // Section 2 - Text Section
    intro: {
      title: 'Ampthilldowns',
      content:
        "A destination stay where you reconnect with nature, with each other, and with themselves. More than just a getaway it's a place where loved ones gather, where animals roam free, where time slows down. A sanctuary for people, for nature; a place where everything and everyone finds their rhythm.",
    },

    // Section 3 - Image + text section
    location: {
      title: 'Ampthilldowns',
      coordinates: {
        latitude: '10°11\'33.76"N',
        longitude: '77°20\'17.40"E',
        elevation: '6,515 ft',
      },
      backgroundImage: '',
      paragraphs: [
        "Welcome to Ampthilldowns, a secluded haven nestled in the untouched village of Poondi, perched on the borders of Tamil Nadu and Kerala. Just an hour drive from Kodaikanal, this pristine location is the last settlement on the border at the edge of the National Forest, where the Western Ghats extend into Kerala's renowned wildlife sanctuaries.",
        'The resort spans over 40 acres of rolling hills, wetlands, ponds, grasslands, green meadows and preserved native flora. With seclusion, serenity and undulated nature as a core principle, development here is guided by strong environmental ethics to maintain the integrity of the land.',
        'Ampthilldowns lies directly on an ancient wild animal migration route, surrounded by lush forests and crystal-clear lakes. It is home to a rich biodiversity, including native birds, deer, bison, peacocks and much more. Blessedly untouched, the region has retained its ecological purity and natural charm.',
        'Ampthilldowns is more than just a retreat; it is a destination for discovery, for reconnecting with oneself and the natural world. It serves a growing audience—both Indian and international—seeking authentic, eco-conscious travel experiences that honour nature while offering peace, wellness, and connection.',
        'Its remoteness is its strength—its serenity and biodiversity offer a rare escape. Kodaikanal also known as the "Princess of Hill Stations", nearby, is one of India\'s most celebrated hill stations, located in the folds of the Palani Hills—part of the Western Ghats, a UNESCO-recognized biodiversity hotspot. With its misty peaks, wooded slopes, serene lakes, and prestigious educational institutions, Kodai remains a beloved destination for nature lovers and wellness seekers alike.',
        'Whether you come to explore rare flora and fauna, explore ancient landscapes, or simply unwind in pristine surroundings, Ampthilldowns promises an experience rooted in sustainability, beauty, and tranquillity.',
        'Welcome to your sanctuary in the hills.',
      ],
    },

    // Section 4 - Rooted in a Dream
    story: {
      title: 'Rooted in a Dream - How It All Began',
      paragraphs: [
        'Every farm has a story and so does we. Ours began many decades ago, during a quiet trek through the lush, dense forested highlands of southern India. Two romantically idealistic nature lovers enchanted by the scent of earth, the charm of village life, the remoteness and the rugged simplicity of the cowboy lifestyle dreamt of building a life closer to nature, one deeply rooted in the land.',
        'That dream took root when we stumbled upon Poondi, a serene hamlet nestled ~7000 feet above in the upper Palani Hills, not far from Kodaikanal. Remote, unspoiled, and breathtakingly beautiful, Poondi instantly felt like the place we were meant to find. Surrounded by rolling meadows, whispering pine groves, and mist-draped mountains, it offered the solitude and soul we had long been seeking as much as we were captivated by the majesty of the mountains',
        'What began as an indulgence and far-fetched dream, slowly evolved into Ampthilldowns; a space where people could escape the chaos of urban life and reconnect with the rhythms of the land.',
        "Over the years, we've grown organically, with deep respect for the land and its ecosystem. Ampthilldowns has become a destination for guests from around the world, known for its tradition of heartfelt southern hospitality, personal warmth, and unforgettable experiences and forever memories.",
        'A haven for animal, man and earth alike. A place where everything and everyone finds its place. At the heart of Ampthilldowns is a family of passionate people bound by their love for this land, eager to welcome you into their world.',
        'This is Ampthilldowns',
      ],
      backgroundImage: '',
    },

    // Section 5 - Accommodation types
    accommodation: {
      title: "Cottages & Stays (Sleep in Nature's Embrace)",
      intro:
        "What often feels difficult in everyday life becomes easy here. Whether you want to get involved or simply step away for a while – here, you'll find exactly what you're looking for.",
      types: [
        { title: 'Whispering Pines', icon: '', bg: '', description: '' },
        { title: 'Mossy Hollow', icon: '', bg: '', description: '' },
        { title: 'Sunlit Glade', icon: '', bg: '', description: '' },
        { title: 'Fern Haven', icon: '', bg: '', description: '' },
        // { title: 'Tenting', icon: '', bg: '', description: '' },
      ],
    },

    // Section 6 - Outdoor Experiences
    experiences: {
      title: 'Discover Experiences (What You Can Do Here)',
      intro:
        'At our stay, rustic charm meets contemporary elegance, with every room opening up to sweeping natural views. Surrounded by mountains, forests, fields, and streams, this is a place where nature sets the rhythm—and adventure, discovery, and relaxation await just outside your door.',
      sections: [
        {
          title: 'Creating Memorable Experiences',
          image: '',
          color: '#004b37',
        },
        { title: 'Authentic Immersion', image: '', color: '#004b37' },
        { title: 'Digital Detox', image: '', color: '#004b37' },
        { title: 'Relax and Rejuvenate', image: '', color: '#004b37' },
      ],
      // Detailed experiences content
      detailedExperiences: [
        {
          title: 'On-Property Hikes',
          description:
            'There are miles of hiking trails through these wooded mountains, some gentle, others more vigorous. Some trails climb up to 7000+ feet for views of mountain tops that roll on forever, while others wander through mature stands of dense forests with carpets of grasslands and wildflowers',
        },
        {
          title: 'Farm and Garden',
          description:
            'A walk from our main lodging area, guests can visit our Farmstead. Here you can meet our chickens, peruse our vegetable garden, pay a visit to our cows, walk amongst our fruit trees, and get a taste for the farming traditions that make Ampthilldowns so unique and experience the rhythms and rewards of sustainable farming',
        },
        {
          title: 'Fireside Conversations',
          description:
            "Evenings at Ampthilldowns often end around a glowing fire—where stories are shared, silences are savoured, and time gently slows down. Whether you're stargazing, sipping something warm, or just enjoying the crackle and calm, our fireside moments are where strangers become friends, and memories take root.",
        },
        {
          title: 'Nature Trails & Hikes',
          description:
            'Explore miles of scenic trails winding through the hills, ranging from gentle strolls to more challenging hikes. Wander through ancient woods, lush fern carpets, and fields dotted with wildflowers. Each path leads to a new perspective—and some, to breathtaking mountaintop views.',
        },
        {
          title: 'Mountain & Road Biking',
          description:
            'Set off on an exhilarating mountain biking adventure through wooded trails and hilly terrain or cycle through our rugged off-road trails or take the scenic route along winding country roads on a road bike. Whichever path you choose, the surrounding landscapes are sure to inspire.',
        },
        {
          title: 'Outdoor Fitness & Yoga in the Wild',
          description:
            'Make the outdoors your personal wellness studio. We provide yoga mats, blocks, and fitness accessories on request so you can stretch, move, and breathe surrounded by the tranquillity of nature—be it under a tree, by the stream, or on a quiet meadow.',
        },
        {
          title: 'Stargazing & Campfires',
          description:
            'With zero light pollution, our stargazing deck offers crystal-clear views of the night sky. Whether you bring a telescope or just lie back and look up, the celestial display here is nothing short of awe-inspiring.',
        },
        {
          title: 'Birdwatching & Wildlife Encounters',
          description:
            'Our biodiverse surroundings are home to an array of native birdlife and wildlife. Early mornings and early evenings are especially magical, where patient observers may spot bison, deer, peacocks, boars moving quietly across the distant landscape.',
        },
        {
          title: 'For Little Explorers',
          description:
            'At Ampthilldowns, every tree, trail, and puddle hold a story waiting to be discovered. From feeding farm animals and spotting butterflies to helping in the garden or finding shapes in clouds—children reconnect with the natural world, free from screens and full of wonder. Here, curiosity is encouraged and adventure begins just beyond the doorstep.',
        },
        {
          title: 'Indoor Sports & Play',
          description:
            "At Ampthill Downs, fun doesn't stop when you step indoors. Our indoor play spaces are designed for guests of all ages to relax, bond, and enjoy active leisure. From classic games like table tennis, carrom, and chess to cozy corners for board games and group play, there's something for everyone.",
        },
        {
          title: 'Spaces to Simply Be',
          description:
            "Amidst all the activity lies our most cherished offering: silence and space, a place to simply be. Set up an art easel, sip tea by the bonfire, nap in a hammock beneath a tree, or lose yourself in the pages of a book. Here, stillness is not empty—it's full of presence.",
        },
      ],
    },

    // Section 7 - Sustainable Living (formerly Farm)
    sustainableLiving: {
      title: 'Sustainable Living and Responsible Living Spaces',
      intro:
        '"Man, whether civilized or savage, is a child of nature – he is not the master of nature". Caring for the surroundings and giving back to the nature to preserve its sustenance, we put significant efforts to maintain the tranquillity of the space and contribute to eco-restoration through the following',
      sections: [
        { title: 'Preservation of shola-grassland ecosystem', image: '' },
        {
          title: 'Re-establishment of grassland and wetland habitat',
          image: '',
        },
        { title: 'Watershed Management and Rainwater Harvesting', image: '' },
        { title: 'Biogas Generation', image: '' },
        { title: 'Off grid Power Solutions', image: '' },
        { title: 'Zero waste Management', image: '' },
      ],
      // Detailed sustainable living content
      detailedSections: [
        {
          title: 'Preservation of shola-grassland ecosystem',
          description:
            'The shola-grassland ecosystem is unique to the higher reaches of the southern Western Ghats. The shola-grassland ecosystem serves as the water tank for the peninsula. While the grasslands let the rainwater flow away, it flows through the shola into the streams. Efforts to conserve the shola started a decade back as a conscious effort by the promoters and today through this shola patch flows a stream that feeds the water reservoir that supplies the needs of the resort',
        },
        {
          title: 'Re-establishment of grassland and wetland habitat',
          description:
            'Over the last many years, we have been working on conserving wetlands and preservation and expansion of grasslands, Wetlands are seen as wastelands in most parts of the world, the wetlands are very crucial and important ecosystem',
        },
        {
          title: 'Watershed Management & Rainwater Harvesting',
          description:
            'Sustainable water solutions start with effective watershed management. By conserving soil and capturing rainfall at the source, we ensure year-round water availability for communities, agriculture, and ecosystems. Our rainwater harvesting systems recharge groundwater, reduce dependency on external sources, and build climate resilience.',
        },
        {
          title: 'Off-Grid Power Solutions',
          description:
            'Our sustainable power solutions bring electricity using solar and hybrid technologies. Designed for efficiency and independence, these systems provide continuous, affordable, and clean power — anytime, anywhere.',
        },
        {
          title: 'Zero Waste Management',
          description:
            'We believe in turning waste into resources. Through zero waste management practices, we minimize landfill use by recycling, reusing, composting, and innovating sustainable disposal methods. Our approach reduces environmental impact, conserves natural resources, and helps move towards a cleaner, greener, and circular future.',
        },
        {
          title: 'Biogas Generation',
          description:
            'We transform organic waste into clean, renewable energy through biogas generation. This process not only reduces landfill waste and harmful emissions but also produces eco-friendly fuel for cooking, heating, and electricity. Biogas empowers communities with sustainable energy while promoting a circular economy.',
        },
      ],
    },

    // Section 8 - Our Memories (Gallery)
    gallery: {
      title: 'Our Memories',
      images: [],
      videos: [],
    },

    // Section 9 - Discover (Blog)
    discover: {
      title: 'Discover',
      posts: [
        {
          title: 'Nature & Wildlife',
          description:
            'Poondi is home to lush forests, crystal-clear lakes, and diverse wildlife.',
          image: '',
        },
        {
          title: 'Culture & Heritage',
          description:
            'Experience the heritage of a serene village at the edge of the Western Ghats.',
          image: '',
        },
        {
          title: 'Hills & Serenity',
          description:
            'Rolling hills and untouched beauty make Poondi a true hidden gem.',
          image: '',
        },
        {
          title: 'Eco Living',
          description: 'Discover sustainable living in harmony with nature.',
          image: '',
        },
      ],
    },

    // Section 10 - What our guests say
    testimonials: {
      title: "What our guests say (From the horse's mouth)",
      reviewSources: [
        { name: 'TripAdvisor', link: '', logo: '' },
        { name: 'Facebook', link: '', logo: '' },
        { name: 'Instagram', link: '', logo: '' },
        { name: 'Google', link: '', logo: '' },
      ],
      reviews: [
        {
          name: 'Priya M.',
          location: 'Mumbai, India',
          quote:
            'A truly peaceful experience! The nature walks and the hospitality were unforgettable.',
          rating: 5,
          avatar: 'PM',
          source: 'Google',
        },
        {
          name: 'Aarav R.',
          location: 'Bangalore, India',
          quote:
            'Perfect weekend getaway! Loved the farm activities and our lakeside cottage.',
          rating: 5,
          avatar: 'AR',
          source: 'TripAdvisor',
        },
        {
          name: 'Sarah D.',
          location: 'Dubai, UAE',
          quote:
            'The food, views, and yoga sessions were all amazing. Highly recommended!',
          rating: 4,
          avatar: 'SD',
          source: 'Google',
        },
        {
          name: 'Rajesh K.',
          location: 'Chennai, India',
          quote:
            'Amazing place to disconnect and reconnect with nature. The cottages are beautiful and the staff is very welcoming.',
          rating: 5,
          avatar: 'RK',
          source: 'Facebook',
        },
        {
          name: 'Emily W.',
          location: 'London, UK',
          quote:
            'A hidden gem! The sustainable practices and eco-friendly approach really impressed us.',
          rating: 5,
          avatar: 'EW',
          source: 'TripAdvisor',
        },
        {
          name: 'Vikram S.',
          location: 'Delhi, India',
          quote:
            'Perfect for families. Kids loved the farm activities and we adults enjoyed the peace and quiet.',
          rating: 4,
          avatar: 'VS',
          source: 'Google',
        },
        {
          name: 'Maria G.',
          location: 'Barcelona, Spain',
          quote:
            'The stargazing experience was magical. Never seen so many stars in my life!',
          rating: 5,
          avatar: 'MG',
          source: 'Instagram',
        },
        {
          name: 'Ankit P.',
          location: 'Pune, India',
          quote:
            'Great place for digital detox. The hiking trails are amazing and the food is delicious.',
          rating: 5,
          avatar: 'AP',
          source: 'Facebook',
        },
        {
          name: 'Lisa T.',
          location: 'Melbourne, Australia',
          quote:
            'The yoga sessions in nature were transformative. Highly recommend this place for wellness seekers.',
          rating: 5,
          avatar: 'LT',
          source: 'TripAdvisor',
        },
        {
          name: 'Rohit M.',
          location: 'Hyderabad, India',
          quote:
            'Excellent service and beautiful location. The cottages are well-maintained and the views are breathtaking.',
          rating: 4,
          avatar: 'RM',
          source: 'Google',
        },
      ],
    },

    // Plan Your Journey
    planJourney: {
      title: 'Plan Your Journey (Let Us Guide You Here)',
      description:
        'Let us guide you to the serene beauty of Poondi, Kodaikanal. Find everything you need to make your trip smooth and memorable — from how to reach us, what to pack, helpful travel tips, and accurate directions.',
      ctaText: 'Explore More',
      sections: [
        { title: 'How to Reach', content: '' },
        { title: 'Weather, What to Pack', content: '' },
        { title: 'Travel Tips & FAQs', content: '' },
        { title: 'Location & Directions', content: '' },
        { title: 'Seasons at Ampthilldowns', content: '' },
      ],
      coordinates: {
        latitude: '10°11\'33.76"N',
        longitude: '77°20\'17.40"E',
        elevation: '6,515 ft',
      },
      mapEmbed:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5097.741159095042!2d77.3354157760227!3d10.193179369678859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b077a81850b1f51%3A0xdcb5c6e9897cb2e9!2sAmpthill%20Downs%20-%20The%20Farm%20Stay!5e1!3m2!1sen!2sin!4v1763549083611!5m2!1sen!2sin',
    },

    // Footer additions
    footer: {
      links: [
        { title: 'FAQ', url: '/faq' },
        { title: 'Privacy Policy', url: '/privacy' },
        { title: 'Terms of Service', url: '/terms' },
      ],
    },

    // Floating Button Options
    floatingButton: {
      options: [
        { title: 'Real time weather', icon: '', action: 'weather' },
        { title: 'Book Your Stay', icon: '', action: 'booking' },
        { title: 'Get Directions', icon: '', action: 'directions' },
        { title: 'Gallery', icon: '', action: 'gallery' },
        { title: 'Quick Enquiry', icon: '', action: 'enquiry' },
      ],
    },

    // Newsletter
    newsletter: {
      title: 'Stay in the Loop',
      description: 'Subscribe to receive special offers and resort updates',
      placeholder: 'Your email address',
      privacyText: 'We respect your privacy. Unsubscribe anytime.',
    },
  },

  // Our Story Page
  ourStory: {
    hero: {
      title: 'Our Story',
      subtitle: 'Where It All Began',
      backgroundImage: '',
    },
    dreamSection: {
      title: 'Rooted in a Dream',
      paragraphs: [
        'Ampthill Resort began in 2005 with a simple vision: to create a sanctuary where humans and nature could coexist harmoniously. Founders Raj and Priya Sharma, both environmental scientists, discovered this neglected valley and saw its potential for restoration.',
        "What started as 50 acres of degraded land has transformed into 200 acres of protected wilderness through our regenerative practices. We've revived native species, restored watersheds, and created a model for sustainable tourism that benefits both guests and the ecosystem.",
      ],
      stats: [
        { number: '200+', label: 'Acres Restored' },
        { number: '50+', label: 'Native Species' },
        { number: '15k+', label: 'Trees Planted' },
      ],
      image: '',
    },
    team: {
      title: 'Our Dedicated Team',
      members: [
        {
          name: 'Raj Sharma',
          role: 'Founder & Ecologist',
          bio: '20+ years in conservation. Leads our reforestation initiatives and wildlife monitoring.',
          image: '',
        },
        {
          name: 'Priya Sharma',
          role: 'Founder & Sustainability Director',
          bio: 'Sustainable architecture expert. Designed all structures using local materials.',
          image: '',
        },
        {
          name: 'Arjun Patel',
          role: 'Head of Conservation',
          bio: 'Botanist specializing in native shola-grassland ecosystems restoration.',
          image: '',
        },
        {
          name: 'Meera Krishnan',
          role: 'Community Relations',
          bio: 'Connects with local villages to implement our zero-waste initiatives.',
          image: '',
        },
      ],
    },
    farmingPurpose: {
      title: 'Farming with Purpose',
      subtitle:
        'Our commitment to regenerative agriculture and ecosystem preservation',
      accordionItems: [
        {
          title: 'Preservation of Shola-Grassland Ecosystem',
          icon: '🌿',
          content:
            'Our most significant conservation effort focuses on restoring the native shola-grassland ecosystem, a unique habitat found only in the higher altitudes of the Western Ghats. This fragile ecosystem hosts numerous endemic species that exist nowhere else on Earth.',
          benefits: [
            'Reintroduced 15 native plant species to degraded areas',
            'Created wildlife corridors connecting fragmented habitats',
            'Implemented controlled burns to maintain grassland health',
            'Monitored population recovery of endangered species',
          ],
          image: '',
        },
        {
          title: 'Re-establishment of Grassland and Wetland Habitat',
          icon: '💧',
          content:
            "We've transformed eroded slopes and degraded fields into thriving grassland and wetland habitats that support biodiversity and improve water retention in the landscape.",
          benefits: [
            'Restored 5 natural springs and 3 wetland areas',
            'Planted native grasses across 50 acres',
            'Created habitat for migratory birds and amphibians',
            'Increased groundwater recharge by 40% in restored areas',
          ],
          image: '',
        },
        {
          title: 'Watershed Management',
          icon: '🌊',
          content:
            'Our comprehensive watershed management approach ensures the long-term health of local water systems, benefiting both the resort and surrounding communities.',
          benefits: [
            'Constructed 12 check dams to control erosion',
            'Implemented rainwater harvesting across all structures',
            'Created swales and contour trenches to slow water runoff',
            'Recharged 8 million liters of water annually',
            'Provided clean water access to 3 neighboring villages',
          ],
          image: '',
        },
        {
          title: 'Zero Waste Living',
          icon: '♻️',
          content:
            "We've implemented a circular economy model across the resort, minimizing waste and maximizing resource efficiency through innovative practices.",
          benefits: [
            '95% waste diversion from landfills',
            'On-site composting of all organic waste',
            'Upcycling program for non-recyclables',
            'Plastic-free operations since 2018',
            'Local sourcing of 85% of resort supplies',
          ],
          image: '',
        },
      ],
    },
    cta: {
      title: 'Join Our Conservation Journey',
      description:
        'Experience sustainable luxury while contributing to our ecosystem restoration efforts',
      primaryButtonText: 'Book Your Stay',
      secondaryButtonText: 'Support Our Mission',
    },
  },

  // Ampthilldowns Page
  ampthilldowns: {
    title: 'Ampthilldowns (Rooted, Resilient, Regenerative)',
    content:
      "A destination stay where you reconnect with nature, with each other, and with themselves. More than just a getaway it's a place where loved ones gather, where animals roam free, where time slows down. A sanctuary for people, for nature; a place where everything and everyone finds their rhythm.",
  },

  // Footer (CMS editable footer content)
  footer: {
    description:
      'A secluded haven in the untouched village of Poondi, where nature and comfort come together. Experience sustainable living in harmony with the mountains.',
    contact: {
      address:
        '39th km, Kodai-Munnar road, Poondi, Kodaikanal, Tamil Nadu 624103',
      phone: '+91 98765 43210',
      email: 'info@ampthilldowns.com',
      hours: 'Mon - Sun: 24/7 Support',
    },
  },

  // The Farm Page
  theFarm: {
    hero: {
      title: 'Sustainable Living and Responsible Living Spaces',
      subtitle: 'Rooted, Resilient, Regenerative',
      backgroundImage: '',
    },
    gardenSection: {
      title: 'Organic Gardens & Orchards',
      paragraphs: [
        'Our 10-acre organic farm is a vibrant ecosystem where we grow over 200 varieties of fruits, vegetables, and herbs using regenerative practices. We follow the principles of permaculture, creating symbiotic relationships between plants, insects, and soil microorganisms.',
        'Our orchard features heritage varieties of apples, pears, and stone fruits, while our vegetable gardens produce year-round harvests. We practice no-till farming, companion planting, and use organic compost produced on-site.',
      ],
      stats: [
        { number: '200+', label: 'Plant Varieties' },
        { number: '10', label: 'Acres Cultivated' },
        { number: '0', label: 'Synthetic Inputs' },
      ],
      image: '',
    },
    animals: {
      title: 'Animals We Love',
      intro:
        'Our animals are essential partners in our regenerative farming system, contributing to soil fertility and pest control.',
      animalCards: [
        {
          name: 'Heritage Cows',
          role: 'Soil Builders',
          bio: 'Our Dexter and Jersey cows provide milk for our dairy products while their manure feeds our compost systems. Rotational grazing builds topsoil.',
          image: '',
        },
        {
          name: 'Pastured Chickens',
          role: 'Pest Control',
          bio: 'Our flock follows the cows, scratching through manure to break it down while eating insects and fertilizing pastures.',
          image: '',
        },
        {
          name: 'Dairy Goats',
          role: 'Brush Clearers',
          bio: 'Our goats clear brush from unused areas, converting it into rich milk for cheese while preventing forest encroachment.',
          image: '',
        },
        {
          name: 'Honey Bees',
          role: 'Pollinators',
          bio: 'Our apiaries ensure pollination of our crops while producing delicious honey. We maintain 25 hives across the property.',
          image: '',
        },
      ],
    },
    systems: {
      title: 'Our Self-Sustaining Systems',
      intro:
        '"Man, whether civilized or savage, is a child of nature – he is not the master of nature". Caring for the surroundings and giving back to the nature to preserve its sustenance, we put significant efforts to maintain the tranquillity of the space and contribute to eco-restoration through the following',
      accordionItems: [
        {
          id: 'shola-grassland',
          title: 'Preservation of shola-grassland ecosystem',
          icon: '🌲',
          category: 'Ecosystem Conservation',
          description:
            'The shola-grassland ecosystem is unique to the higher reaches of the southern Western Ghats. The shola-grassland ecosystem serves as the water tank for the peninsula. While the grasslands let the rainwater flow away, it flows through the shola into the streams. Efforts to conserve the shola started a decade back as a conscious effort by the promoters and today through this shola patch flows a stream that feeds the water reservoir that supplies the needs of the resort.',
          image: '',
        },
        {
          id: 'grassland-wetland',
          title: 'Re-establishment of grassland and wetland habitat',
          icon: '🌾',
          category: 'Habitat Restoration',
          description:
            'Over the last many years, we have been working on conserving wetlands and preservation and expansion of grasslands, Wetlands are seen as wastelands in most parts of the world, the wetlands are very crucial and important ecosystem.',
          image: '',
        },
        {
          id: 'rainwater-harvesting',
          title: 'Watershed Management & Rainwater Harvesting',
          icon: '💧',
          category: 'Water Conservation',
          description:
            'Sustainable water solutions start with effective watershed management. By conserving soil and capturing rainfall at the source, we ensure year-round water availability for communities, agriculture, and ecosystems. Our rainwater harvesting systems recharge groundwater, reduce dependency on external sources, and build climate resilience.',
          image: '',
        },
        {
          id: 'biogas-generation',
          title: 'Biogas Generation',
          icon: '🔥',
          category: 'Renewable Energy',
          description:
            'We transform organic waste into clean, renewable energy through biogas generation. This process not only reduces landfill waste and harmful emissions but also produces eco-friendly fuel for cooking, heating, and electricity. Biogas empowers communities with sustainable energy while promoting a circular economy.',
          image: '',
        },
        {
          id: 'off-grid-power',
          title: 'Off-Grid Power Solutions',
          icon: '☀️',
          category: 'Energy Independence',
          description:
            'Our sustainable power solutions bring electricity using solar and hybrid technologies. Designed for efficiency and independence, these systems provide continuous, affordable, and clean power — anytime, anywhere.',
          image: '',
        },
        {
          id: 'zero-waste',
          title: 'Zero Waste Management',
          icon: '♻️',
          category: 'Circular Economy',
          description:
            'We believe in turning waste into resources. Through zero waste management practices, we minimize landfill use by recycling, reusing, composting, and innovating sustainable disposal methods. Our approach reduces environmental impact, conserves natural resources, and helps move towards a cleaner, greener, and circular future.',
          image: '',
        },
      ],
    },
    cuisine: {
      title: 'Our Cuisine',
      paragraphs: [
        "Our farm-to-table restaurant celebrates the seasonal abundance of our land. Chef Ananya creates daily menus based on what's freshly harvested, with 95% of ingredients sourced from within 500 meters of the kitchen.",
        'We specialize in traditional cooking methods using our wood-fired oven and biogas stoves. Our menu changes with the seasons, featuring heirloom varieties and preserving techniques that allow us to enjoy our harvest year-round.',
      ],
      features: [
        { icon: '🍅', text: '95% ingredients from our farm' },
        { icon: '🔥', text: 'Wood-fired and biogas cooking' },
        { icon: '🌱', text: '100% organic ingredients' },
        { icon: '♻️', text: 'Zero-waste kitchen operations' },
      ],
      image: '',
    },
    cta: {
      title: 'Experience Farm Life',
      description:
        'Join us for a farm tour, workshop, or stay in our eco-cottages',
      primaryButtonText: 'Book a Farm Tour',
      secondaryButtonText: 'View Workshops',
    },
  },

  // Cottages & Stays Page
  cottages: {
    title: "Cottages & Stays (Sleep in Nature's Embrace)",
    intro:
      "What often feels difficult in everyday life becomes easy here. Whether you want to get involved or simply step away for a while – here, you'll find exactly what you're looking for.",
    cottages: [
      { title: 'Cottage 1', description: '', images: [], amenities: [] },
      { title: 'Cottage 2', description: '', images: [], amenities: [] },
      { title: 'Cottage 3', description: '', images: [], amenities: [] },
      { title: 'Cottage 4', description: '', images: [], amenities: [] },
      { title: 'Tenting', description: '', images: [], amenities: [] },
    ],
  },

  // Stays Page (Rooms listing page)
  stays: {
    hero: {
      title: "Experience Nature's Luxury",
      subtitle: 'Find Your Perfect Stay at Ampthill Resort',
      backgroundImage: '',
    },
    bookingProcess: {
      title: 'Simple Booking Process',
      steps: [
        {
          number: 1,
          title: 'Choose Your Stay',
          description:
            'Browse our unique accommodations and select the perfect one for your nature retreat.',
        },
        {
          number: 2,
          title: 'Select Dates',
          description:
            'Pick your arrival and departure dates to check availability and pricing.',
        },
        {
          number: 3,
          title: 'Connect & Confirm',
          description:
            "You'll be redirected to WhatsApp, where our team will confirm your booking and assist with payment.",
        },
      ],
    },
    testimonials: [
      {
        rating: 5,
        text: "The farm-to-table experience was incredible. Waking up to misty mountains and the sound of birds was magical. We'll definitely be back!",
        author: 'Priya & Raj',
        location: 'Mumbai, India',
      },
      {
        rating: 5,
        text: 'Our kids loved the farm activities! The guided nature walks were educational and fun. The accommodation was cozy with stunning views.',
        author: 'Thomas Family',
        location: 'London, UK',
      },
      {
        rating: 4.5,
        text: 'Perfect getaway for digital detox. No WiFi forced us to connect with nature and each other. The sunset views from our room were breathtaking.',
        author: 'Michael & Sarah',
        location: 'New York, USA',
      },
    ],
    faq: [
      {
        question: 'What time is check-in and check-out?',
        answer:
          'Check-in time is 2:00 PM and check-out is 11:00 AM. Early check-in or late check-out may be available upon request, subject to availability and additional charges.',
      },
      {
        question: 'Are pets allowed?',
        answer:
          'We love animals, but to preserve our natural habitat and ensure the comfort of all guests, pets are not allowed in our accommodations. Service animals are welcome with prior notification.',
      },
      {
        question: 'Is WiFi available?',
        answer:
          'We intentionally limit WiFi access to encourage our guests to disconnect and immerse themselves in nature. Limited WiFi is available in the main lodge area during specific hours.',
      },
      {
        question: 'What is your cancellation policy?',
        answer:
          'Cancellations made 30+ days before arrival will receive a full refund. 15-30 days: 50% refund. Less than 15 days: no refund. We recommend travel insurance for unexpected circumstances.',
      },
    ],
    cta: {
      title: 'Ready for Your Nature Retreat?',
      description:
        'Experience sustainable luxury while connecting with nature at Ampthill Resort',
      primaryButtonText: 'Book Your Stay Now',
      secondaryButtonText: 'Contact Us',
    },
  },

  // Experiences Page
  experiencesPage: {
    hero: {
      title: 'Discover Experiences',
      subtitle: 'What You Can Do Here',
      backgroundImage: '',
    },
    intro: {
      title: 'Discover Your Perfect Experience',
      description:
        "At Ampthilldowns, we offer a diverse range of activities and experiences designed to connect you with nature, community, and yourself. From adventurous hikes to peaceful moments of reflection, there's something for every type of explorer and every moment of your stay.",
      stats: [
        { number: '11', label: 'Unique Experiences' },
        { number: '50+', label: 'Activities Available' },
        { number: '∞', label: 'Memories to Create' },
      ],
    },
    experiences: [
      {
        sectionId: 'on-property-hikes',
        title: 'On-Property Hikes',
        description:
          'There are miles of hiking trails through these wooded mountains, some gentle, others more vigorous. Some trails climb up to 7000+ feet for views of mountain tops that roll on forever, while others wander through mature stands of dense forests with carpets of grasslands and wildflowers.',
        benefits: [
          'Trails ranging from gentle to vigorous',
          'Mountain top views at 7000+ feet',
          'Dense forest exploration',
          'Wildflower meadows and grasslands',
        ],
        duration: 'Half day to full day',
        icon: '🥾',
        category: 'Outdoor Adventure',
        image: '',
      },
      {
        sectionId: 'farm-and-garden',
        title: 'Farm and Garden',
        description:
          'A walk from our main lodging area, guests can visit our Farmstead. Here you can meet our chickens, peruse our vegetable garden, pay a visit to our cows, walk amongst our fruit trees, and get a taste for the farming traditions that make Ampthilldowns so unique and experience the rhythms and rewards of sustainable farming.',
        benefits: [
          'Meet farm animals (chickens, cows)',
          'Explore vegetable gardens',
          'Walk through fruit orchards',
          'Learn sustainable farming practices',
        ],
        duration: '1-2 hours',
        icon: '🚜',
        category: 'Farm Experience',
        image: '',
      },
      {
        sectionId: 'fireside-conversations',
        title: 'Fireside Conversations',
        description:
          "Evenings at Ampthilldowns often end around a glowing fire—where stories are shared, silences are savoured, and time gently slows down. Whether you're stargazing, sipping something warm, or just enjoying the crackle and calm, our fireside moments are where strangers become friends, and memories take root.",
        benefits: [
          'Storytelling and conversation',
          'Stargazing opportunities',
          'Warm beverages by the fire',
          'Community building experiences',
        ],
        duration: 'Evening sessions',
        icon: '🔥',
        category: 'Social Connection',
        image: '',
      },
      {
        sectionId: 'nature-trails',
        title: 'Nature Trails & Hikes',
        description:
          'Explore miles of scenic trails winding through the hills, ranging from gentle strolls to more challenging hikes. Wander through ancient woods, lush fern carpets, and fields dotted with wildflowers. Each path leads to a new perspective—and some, to breathtaking mountaintop views.',
        benefits: [
          'Scenic trail exploration',
          'Ancient woodland walks',
          'Wildflower field discovery',
          'Breathtaking mountain views',
        ],
        duration: '1-4 hours',
        icon: '🌲',
        category: 'Nature Exploration',
        image: '',
      },
      {
        sectionId: 'mountain-biking',
        title: 'Mountain & Road Biking',
        description:
          'Set off on an exhilarating mountain biking adventure through wooded trails and hilly terrain or cycle through our rugged off-road trails or take the scenic route along winding country roads on a road bike. Whichever path you choose, the surrounding landscapes are sure to inspire.',
        benefits: [
          'Mountain biking trails',
          'Off-road cycling paths',
          'Scenic country road routes',
          'Equipment available on request',
        ],
        duration: '2-4 hours',
        icon: '🚴',
        category: 'Adventure Sports',
        image: '',
      },
      {
        sectionId: 'yoga-fitness',
        title: 'Outdoor Fitness & Yoga in the Wild',
        description:
          'Make the outdoors your personal wellness studio. We provide yoga mats, blocks, and fitness accessories on request so you can stretch, move, and breathe surrounded by the tranquillity of nature—be it under a tree, by the stream, or on a quiet meadow.',
        benefits: [
          'Yoga mats and equipment provided',
          'Multiple outdoor locations',
          'Personalized fitness sessions',
          'Nature-immersed wellness',
        ],
        duration: '1-2 hours',
        icon: '🧘',
        category: 'Wellness',
        image: '',
      },
      {
        sectionId: 'stargazing-campfires',
        title: 'Stargazing & Campfires',
        description:
          'With zero light pollution, our stargazing deck offers crystal-clear views of the night sky. Whether you bring a telescope or just lie back and look up, the celestial display here is nothing short of awe-inspiring.',
        benefits: [
          'Zero light pollution environment',
          'Crystal-clear night sky views',
          'Telescope-friendly setup',
          'Campfire experiences',
        ],
        duration: 'Evening sessions',
        icon: '⭐',
        category: 'Astronomy',
        image: '',
      },
      {
        sectionId: 'birdwatching-wildlife',
        title: 'Birdwatching & Wildlife Encounters',
        description:
          'Our biodiverse surroundings are home to an array of native birdlife and wildlife. Early mornings and early evenings are especially magical, where patient observers may spot bison, deer, peacocks, boars moving quietly across the distant landscape.',
        benefits: [
          'Native birdlife observation',
          'Wildlife spotting opportunities',
          'Early morning/evening sessions',
          'Biodiverse ecosystem exploration',
        ],
        duration: '1-3 hours',
        icon: '🦅',
        category: 'Wildlife',
        image: '',
      },
      {
        sectionId: 'little-explorers',
        title: 'For Little Explorers',
        description:
          'At Ampthilldowns, every tree, trail, and puddle hold a story waiting to be discovered. From feeding farm animals and spotting butterflies to helping in the garden or finding shapes in clouds—children reconnect with the natural world, free from screens and full of wonder. Here, curiosity is encouraged and adventure begins just beyond the doorstep.',
        benefits: [
          'Farm animal interactions',
          'Butterfly and nature spotting',
          'Garden participation',
          'Screen-free exploration',
        ],
        duration: 'Flexible',
        icon: '👶',
        category: 'Family',
        image: '',
      },
      {
        sectionId: 'indoor-sports',
        title: 'Indoor Sports & Play',
        description:
          "At Ampthill Downs, fun doesn't stop when you step indoors. Our indoor play spaces are designed for guests of all ages to relax, bond, and enjoy active leisure. From classic games like table tennis, carrom, and chess to cozy corners for board games and group play, there's something for everyone.",
        benefits: [
          'Table tennis and carrom',
          'Chess and board games',
          'Group play areas',
          'All-weather entertainment',
        ],
        duration: 'Flexible',
        icon: '🎮',
        category: 'Indoor Activities',
        image: '',
      },
      {
        sectionId: 'spaces-to-be',
        title: 'Spaces to Simply Be',
        description:
          "Amidst all the activity lies our most cherished offering: silence and space, a place to simply be. Set up an art easel, sip tea by the bonfire, nap in a hammock beneath a tree, or lose yourself in the pages of a book. Here, stillness is not empty—it's full of presence.",
        benefits: [
          'Art and creative spaces',
          'Peaceful reading corners',
          'Hammock relaxation areas',
          'Mindful presence practice',
        ],
        duration: 'Flexible',
        icon: '☁️',
        category: 'Mindfulness',
        image: '',
      },
    ],
    testimonialsSection: {
      title: 'Guest Experiences',
      testimonials: [
        {
          text: 'The hiking trails offered breathtaking views and the perfect escape from city life. Every turn revealed a new natural wonder.',
          author: 'Priya M.',
          location: 'Mumbai, India',
        },
        {
          text: 'The farm experience was magical for our children. They loved feeding the animals and learning about sustainable farming.',
          author: 'Thomas R.',
          location: 'London, UK',
        },
        {
          text: "The stargazing experience was unforgettable. The night sky here is like nothing I've ever seen - truly magical.",
          author: 'Sophie L.',
          location: 'New York, USA',
        },
      ],
    },
    cta: {
      title: 'Begin Your Restoration Journey',
      description:
        'Our experiences team will help you create a personalized immersion program',
      primaryButtonText: 'Consult with Our Guides',
      secondaryButtonText: 'View All Packages',
    },
  },

  // Plan Your Journey Page
  planYourJourney: {
    hero: {
      title: 'Let Us Guide You Here',
      subtitle: 'Everything you need to plan your visit tucked deep in nature.',
      backgroundImage: '',
    },
    howToReach: {
      title: 'How to Reach',
      methods: [
        {
          icon: '🚗',
          title: 'By Road',
          lines: ['5 hrs from Coimbatore', '3 hrs from Kodaikanal town'],
        },
        {
          icon: '🚆',
          title: 'By Train',
          lines: ['Kodai Road Station', '+2.8 hrs scenic drive'],
        },
        {
          icon: '✈️',
          title: 'By Air',
          lines: ['Madurai (3 hrs)', 'Coimbatore (5 hrs)'],
        },
      ],
    },
    weatherPacking: {
      title: 'Weather & What to Pack',
      items: [
        'Warm clothes',
        'Torch',
        'Light raincoat',
        'Hiking shoes',
        'Book / Journal',
        'Mindset for stillness',
      ],
      image: '',
    },
    travelTips: {
      title: 'Travel Tips & FAQs',
      faqs: [
        {
          question: 'Is mobile network available?',
          answer:
            'Yes, limited connectivity. We recommend downloading offline maps.',
        },
        {
          question: 'Is the road fully accessible?',
          answer:
            'Yes, but the final 5km is a forest path best suited for SUVs.',
        },
        {
          question: 'Do you offer pickup from town?',
          answer:
            'Yes. Pre-booked pickups are available from Kodaikanal or Madurai.',
        },
        {
          question: 'Are children welcome?',
          answer: 'Yes, but we recommend supervision due to wildlife presence.',
        },
      ],
    },
    locationDirections: {
      title: 'Location & Directions',
      coordinates: { latitude: '10.2569° N', longitude: '77.3058° E' },
      route: 'Scenic Route: Kodaikanal → Poombarai → Mannavanur → Ampthill',
      mapsButtonText: 'Open in Maps',
      mapsLink:
        'https://maps.google.com/?q=Ampthill+Downs+The+Farm+Stay+39th+km+Kodai-Munnar+road+Poondi+Kodaikanal+Tamil+Nadu+624103',
    },
  },

  // Contact Page
  contact: {
    hero: {
      title: 'Get in Touch',
      subtitle: "We're here to help you plan your perfect nature retreat",
      backgroundImage: '',
    },
    // Meta for Contact Information section
    contactInfoSection: {
      title: 'Contact Information',
      subtitle: 'Reach out to us through any of these channels',
    },
    contactInfo: [
      {
        icon: '📍',
        title: 'Address',
        details: [
          'Ampthill Downs - The Farm Stay',
          '39th km, Kodai-Munnar road',
          'Poondi, Kodaikanal, Tamil Nadu 624103',
        ],
        action: 'Get Directions',
        actionLink:
          'https://maps.google.com/?q=Ampthill+Downs+The+Farm+Stay+39th+km+Kodai-Munnar+road+Poondi+Kodaikanal+Tamil+Nadu+624103',
      },
      {
        icon: '📞',
        title: 'Phone',
        details: ['+91 98765 43210', '+91 98765 43211'],
        action: 'Call Now',
        actionLink: 'tel:+919876543210',
      },
      {
        icon: '✉️',
        title: 'Email',
        details: ['info@ampthilldowns.com', 'reservations@ampthilldowns.com'],
        action: 'Send Email',
        actionLink: 'mailto:info@ampthilldowns.com',
      },
      {
        icon: '🕒',
        title: 'Hours',
        details: [
          'Mon - Sun: 24/7 Support',
          'Reception: 8 AM - 10 PM',
          'Emergency: 24/7',
        ],
        action: null,
        actionLink: null,
      },
    ],
    mapSection: {
      title: 'Find Us',
      mapEmbed:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5097.741159095042!2d77.3354157760227!3d10.193179369678859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b077a81850b1f51%3A0xdcb5c6e9897cb2e9!2sAmpthill%20Downs%20-%20The%20Farm%20Stay!5e1!3m2!1sen!2sin!4v1763549083611!5m2!1sen!2sin',
      locationDetails: [
        { label: '📍 Address', value: '39th km, Kodai-Munnar road' },
        { label: '🏔️ Elevation', value: '6,515 ft above sea level' },
        {
          label: '🌲 Location',
          value: 'Poondi, Kodaikanal, Tamil Nadu 624103',
        },
        { label: '🚗 Distance', value: '39 km from Kodaikanal town' },
      ],
      directions: [
        {
          method: 'By Road',
          description: 'Take the Kodai-Munnar road, 39th km marker, Poondi',
        },
        {
          method: 'Nearest Airport',
          description: 'Madurai Airport (120 km) - 3.5 hours drive',
        },
        {
          method: 'Nearest Railway Station',
          description: 'Kodaikanal Road (80 km) - 2.5 hours drive',
        },
      ],
    },
    quickActions: {
      title: 'Quick Actions',
      subtitle: 'Need immediate assistance? Try these quick options',
      actions: [
        {
          icon: '📅',
          title: 'Book Now',
          description: 'Ready to reserve your stay? Book directly online.',
          buttonText: 'Book Your Stay',
        },
        {
          icon: '🗺️',
          title: 'Plan Journey',
          description: 'Get detailed directions and travel information.',
          buttonText: 'Plan Your Trip',
        },
      ],
    },
  },

  // Gallery Page
  gallery: {
    hero: {
      title: 'Our Gallery',
      subtitle: 'Moments & Memories from Ampthilldowns',
      backgroundImage: '',
    },
    intro: {
      title: 'Explore Our Collection',
      description:
        'A visual journey through our resort, farm, and guest experiences',
    },
    mediaItems: [],
    cta: {
      title: 'Create Your Own Memories',
      description: 'Book your stay and become part of our story',
      primaryButtonText: 'Book Your Stay',
      secondaryButtonText: 'Contact Us',
    },
  },
}

export const DEFAULT_CONTENT = CONTENT_SCHEMA
